
import Youtube from "../../../assets/duotone/Youtube.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function YoutubeIcon({ className, dataTestid = "YoutubeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Youtube data-testid={dataTestid} className={classes} {...rest} />
  );
}
